<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0 card-has-padding"
    >

      <div class="">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <span class="fs-18 weight-500">Lots</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-dropdown
                id="dropdown-Team-form"
                ref="filter_dropdown_locations"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <lot-filter
                  :product.sync="productFilter"
                  :product-options="productOptions"
                  :status.sync="statusFilter"
                  :status-options="statusOptions"
                  :lot-type.sync="lotTypeFilter"
                  :lot-type-options="lotTypeOptions"
                  :gis-map.sync="gisMap"
                  :map-options="mapOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="productFilter.length || statusFilter.length || lotTypeFilter.length || gisMap.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="item in productFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromProductFilter(item)"
                  >
                    <span class="text-capitalize">{{ resolveProductName(item) }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in statusFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(item)"
                  >
                    <span class="text-capitalize">{{ resolveStatusName(item) }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in lotTypeFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromLotTypeFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in gisMap"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromMapFilter(item)"
                  >
                    <span class="text-capitalize">{{ getMapName(item) }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-card
        no-body
        class="no-padding shadow-body"
      >
        <b-table
          ref="refLotsTable"
          class="position-relative min-height-table"
          :items="itemListData"
          responsive
          :fields="tableColumns"
          primary-key="_id"
          :sort-by.sync="sortBy"
          show-empty
          no-sort-reset
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(lotNo)="data">
            <div class="text-nowrap">
              <b-button
                v-if="canViewThisAction('show', 'Lot')"
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="link"
                class="weight-600 align-middle detail-view-id"
                :to="{ name: 'products-lots-show', params: { id: data.item._id } }"
              >
                {{ data.item.lotNo }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="none"
                class="text-bold-black align-middle detail-view-id not-button"
              >
                {{ data.item.lotNo }}
              </b-button>
            </div>
          </template>

          <template #cell(status)="data">
            <div>
              <b-badge
                :variant="`light-${resolveStatusVariant(data.item.nvsStatus)}`"
                class="text-capitalize"
              >
                <span>{{ resolveStatusName(data.item.nvsStatus) }}</span>
              </b-badge>
            </div>
          </template>

          <template #cell(createdBy)="data">
            <div>
              <span>{{ getCreatedBy(data.item) }}</span>
              <br>
              <span>{{ getCreatedAt(data.item) }}</span>
            </div>
          </template>

          <template #cell(updatedBy)="data">
            <div>
              <span>{{ getUpdatedBy(data.item) }}</span>
              <br>
              <span>{{ getUpdatedAt(data.item) }}</span>
            </div>
          </template>

          <!-- Column: Actions -->
          <template
            v-if="canViewThisAction('show', 'Lot')"
            #cell(actions)="data"
          >
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="canViewThisAction('show', 'Lot')"
                :to="{ name: 'products-lots-show', params: { id: data.item._id } }"
              >
                <span class="align-middle ml-50">View</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>
      </b-card>

      <div
        v-if="totalLots > perPage"
        class="mx-2 mb-2"
      >
        <b-row>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="12"
            class="d-flex align-items-center justify-content-center pagination-content"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalLots"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              align="center"
              prev-text="Prev"
              next-text="Next"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
                <span>Prev</span>
              </template>
              <template #next-text>
                <span>Next</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BDropdown, BDropdownItem, BPagination, BFormTag, BBadge,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
// eslint-disable-next-line import/no-cycle
import useLotList from './useLotList'
import lotStoreModule from './lotStoreModule'
import LotFilter from './LotFilter.vue'

export default {
  components: {
    BFormTag,
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BBadge,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    LotFilter,
  },
  directives: {
    Ripple,
  },
  props: {
    mapOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      lotTypeOptions: [
        { title: 'Single', code: 'SINGLE' },
        { title: 'Double', code: 'DOUBLE' },
        { title: 'Twin Single', code: 'TWIN SINGLE' },
        { title: 'Twin Double', code: 'TWIN DOUBLE' },
        { title: 'Family', code: 'FAMILY' },
        { title: 'Super Family', code: 'SUPER FAMILY' },
      ],
      productOptions: [
        { title: 'Niche', code: '1' },
        { title: 'Pedestal', code: '5' },
        { title: 'Little Buddha', code: '6' },
      ],
      // statusOptions: [
      //   { title: 'Available', code: 'OPEN' },
      //   { title: 'Reserved', code: 'RESERVE' },
      //   { title: 'Booked', code: 'BOOK' },
      //   { title: 'Confirmed', code: 'CONFIRM' },
      //   { title: 'Occupied', code: 'HOLD' },
      // ],
      statusOptions: [
        { title: 'Available', code: 'Available' },
        { title: 'Reserved', code: 'Reserved' },
        { title: 'Booked', code: 'Booked' },
        { title: 'Confirmed', code: 'Confirmed' },
        { title: 'Occupied', code: 'Occupied' },
      ],
      toUpdateID: '',
      required,
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_locations.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_locations.show(true)
    },
    removeFromProductFilter(product) {
      const index = this.productFilter.indexOf(product)
      if (index > -1) {
        this.productFilter.splice(index, 1)
      }
    },

    removeFromStatusFilter(status) {
      const index = this.statusFilter.indexOf(status)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    removeFromLotTypeFilter(lotType) {
      const index = this.lotTypeFilter.indexOf(lotType)
      if (index > -1) {
        this.lotTypeFilter.splice(index, 1)
      }
    },
    removeFromMapFilter(map) {
      const index = this.gisMap.indexOf(map)
      if (index > -1) {
        this.gisMap.splice(index, 1)
      }
    },
    getMapName(item) {
      // eslint-disable-next-line eqeqeq
      const mapName = this.mapOptions.find(map => map.mapID == item)
      return mapName ? mapName.name : ''
    },
    resolveProductName(product) {
      // eslint-disable-next-line eqeqeq
      const productName = this.productOptions.find(prod => prod.code == product)
      return productName ? productName.title : ''
    },

    resolveStatusName(status) {
      const statusName = this.statusOptions.find(stat => stat.code === status)
      return statusName ? statusName.title : status
    },
    clearAllFilters() {
      this.productFilter = []
      this.statusFilter = []
      this.lotTypeFilter = []
      this.gisMap = []
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Warning!',
        text: ' Are you sure you want to delete this?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deleteLot()
          }
        })
    },
    getCreatedBy(item) {
      if (item.createdByNvs) {
        return item.createdByNvs.name
      }
      if (item.createdBy) {
        return item.createdBy
      }

      return ''
    },
    getUpdatedBy(item) {
      if (item.updatedByNvs) {
        return item.updatedByNvs.name
      }
      if (item.updatedBy) {
        return item.updatedBy
      }

      return ''
    },
    getCreatedAt(item) {
      if (item.createdAtNvs) {
        return this.dateFormatWithTime(item.createdAtNvs)
      }
      if (item.createdAt) {
        return this.dateFormatWithFormatNTZ(item.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    getUpdatedAt(item) {
      if (item.updatedAtNvs) {
        return this.dateFormatWithTime(item.updatedAtNvs)
      }
      if (item.updatedAt) {
        return this.dateFormatWithFormatNTZ(item.updatedAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const LOT_APP_STORE_MODULE_NAME = 'app-lots'

    // Register module
    if (!store.hasModule(LOT_APP_STORE_MODULE_NAME)) store.registerModule(LOT_APP_STORE_MODULE_NAME, lotStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(LOT_APP_STORE_MODULE_NAME)) store.unregisterModule(LOT_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchLots,
      tableColumns,
      perPage,
      currentPage,
      totalLots,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refLotsTable,
      refetchData,

      toDeletedID,
      deleteLot,
      currentDataLength,
      itemListData,
      resolveStatusVariant,

      // Extra Filters
      productFilter,
      statusFilter,
      lotTypeFilter,
      gisMap,
    } = useLotList()

    if (searchQuery.value) {
      showSearchBar.value = true
    }

    return {
      // Sidebar
      fetchLots,
      tableColumns,
      perPage,
      currentPage,
      totalLots,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refLotsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteLot,
      currentDataLength,
      itemListData,
      resolveStatusVariant,

      // Filter
      avatarText,
      canViewThisAction,

      // Extra Filters
      productFilter,
      statusFilter,
      lotTypeFilter,
      gisMap,
    }
  },
}
</script>

  <style lang="scss">
  .per-page-selector {
    width: 90px;
  }
  .img-preview-block{
        box-sizing: border-box;
        width: 38px;
        height: 38px;
        border: 1px solid #D2DCEA;
        border-radius: 5px;
    }
    .no-padding.shadow-body {
      background: #FFFFFF;
      box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06) !important;
      border-radius: 6px;
      padding: 0 !important;
    }
    .content-body .card.card-has-padding {
        padding: 40px !important;
    }
  </style>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
